'use strict';

var React = require('react/addons');

/* Stores */
var ModuleInspectorStore = require('stores/module-inspector');
var LanguageStore = require('stores/language');

/* Components */
var TitledGroup = require('components/ui/titled-group');

var ModuleInspectorPropertyTypeSelect = React.createClass({
  displayName: 'ModuleInspectorPropertyTypeSelect',

  getInitialState: function getInitialState() {
    return {
      focus: false
    };
  },

  render: function render() {
    var component = this;
    var cx = React.addons.classSet;
    var props = component.props;

    var empty = !props.value || props.value === '';

    /* Translations */
    var translationKey = props.groupName + '_' + props.name;
    var titleText = ModuleInspectorStore.translate(translationKey);
    var noOptionText = titleText;

    var optionNodes = props.values.map(function (value) {
      var optionTranslationKey = translationKey + '_' + value;
      var optionTranslation = ModuleInspectorStore.hasTranslation(optionTranslationKey) ? ModuleInspectorStore.translate(optionTranslationKey) : value;
      return React.createElement(
        'option',
        { key: value, value: value },
        optionTranslation
      );
    });

    var classes = {};
    classes['select'] = true;
    classes['focus'] = component.state.focus;
    classes['empty'] = empty;

    if (empty) {
      titleText = null;
    }

    return React.createElement(
      TitledGroup,
      { className: cx(classes), title: titleText },
      React.createElement(
        'select',
        { ref: 'select', disabled: props.disabled, value: props.value, onChange: component._onChange, onFocus: component._onFocus, onBlur: component._onBlur },
        React.createElement(
          'option',
          { key: '', value: '', 'default': true },
          noOptionText
        ),
        optionNodes
      )
    );
  },

  _onPerformAction: function _onPerformAction() {
    var props = this.props;

    if (props.onPerformAction) {
      props.onPerformAction(props.name);
    }
  },

  _onChange: function _onChange(evt) {
    var component = this;
    var props = component.props;
    var value = component.refs.select.getDOMNode().value;

    if (props.onChange) {
      /* Send original value and new value */
      props.onChange(props.value, value);
    }
  },

  _onFocus: function _onFocus() {
    this.setState({ focus: true });
  },

  _onBlur: function _onBlur() {
    this.setState({ focus: false });
  }
});

module.exports = ModuleInspectorPropertyTypeSelect;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector/type/select.js
 **/